import { Col, Row } from "react-bootstrap";
import SkeletonBlock from "../common/SkeletonBlock";

const StatLines = () => (
  <>
    {[110, 130, 120, 150, 100].map((width, i) => (
      <div key={i} className="d-flex justify-content-end mb-3 w-100">
        <SkeletonBlock width={width} height={26} />
        <SkeletonBlock width={50} height={26} className="ms-3" />
      </div>
    ))}
  </>
);

const NumberCards = () => (
  <Row>
    <SkeletonBlock width={90} height={26} className="mt-5 mb-3 ms-2" />
    {[0, 1, 2, 3].map((i) => (
      <Col key={i} md={3} xs={6}>
        <SkeletonBlock height={118} className="mb-3" />
      </Col>
    ))}
  </Row>
);

// Placeholder for the Overview tab, mirroring its layout: chart + rank lines,
// insight tiles, kills/deaths cards.
const PlayerStatsSkeleton = () => (
  <div role="status" aria-label="Loading player stats">
    <Row className="mt-5">
      <Col md={6}>
        <SkeletonBlock height={260} />
      </Col>
      <Col
        md={6}
        className="mt-5 mt-md-0 d-flex flex-column justify-content-center align-items-end"
      >
        <StatLines />
      </Col>
    </Row>
    <Row className="g-3 mt-3">
      {[0, 1, 2, 3].map((i) => (
        <Col key={i} xs={6} md={3}>
          <SkeletonBlock height={92} style={{ borderRadius: 12 }} />
        </Col>
      ))}
    </Row>
    <NumberCards />
    <NumberCards />
  </div>
);

export default PlayerStatsSkeleton;
